import Section from "@packages/sections/section";

const selectors = {
    slider: `[data-fp-slider]`,
};

class FeaturedPostsSection extends Section {
    async onLoad() {
        await super.onLoad();

        await this.initSlider();
    }

    async initSlider() {
        const container = this.container;
        if (!container) {
            return;
        }

        const sliderElement = container?.querySelector(selectors?.slider);
        if (!sliderElement) {
            return;
        }

        const { default: Swiper } = await import("swiper");
        if (!Swiper) {
            return;
        }

        new Swiper(sliderElement, {
            slidesPerView: 1.2,
            breakpoints: {
                768: {
                    slidesPerView: 1.66
                },
                1025: {
                    slidesPerView: 2.2
                },
                1536: {
                    slidesPerView: 3
                },
                2560: {
                    slidesPerView: 4
                }
            }
        });
    }
}

export default FeaturedPostsSection;
